// Post-login landing + "which app is this user for" helpers, shared by the
// login page and the route guards.
//
// Precedence mirrors technical-prd-player-pwa.md §3.2.1 plus the affiliate
// (Jul 2026) and club_admin (Aug 2026) roles: the most specific role wins.

const MAIN_APP_ROLES = ['scout', 'manager', 'platform_admin', 'team_admin'];

export const effectiveRoles = (roles, userTypeFallback) => {
  if (Array.isArray(roles) && roles.length > 0) return roles.filter(Boolean);
  return userTypeFallback ? [userTypeFallback] : [];
};

export const landingPathForRoles = (roles, userTypeFallback) => {
  const effective = effectiveRoles(roles, userTypeFallback);
  if (effective.includes('affiliate')) return '/affiliate/dashboard';
  if (effective.includes('club_admin')) return '/club-admin/dashboard';
  if (effective.includes('team_admin')) return '/team-admin/dashboard';
  if (effective.includes('platform_admin')) return '/dashboard';
  if (effective.includes('scout') || effective.includes('manager')) return '/dashboard';
  if (effective.includes('player')) return '/player/dashboard';
  return '/dashboard';
};

// A club admin holds only the club screens (plan decision 11): no scouting
// platform, no player PWA. True when club_admin is the only "app" role.
export const isClubAdminOnly = (roles, userTypeFallback) => {
  const effective = effectiveRoles(roles, userTypeFallback);
  if (!effective.includes('club_admin')) return false;
  return !effective.some((r) => MAIN_APP_ROLES.includes(r) || r === 'player' || r === 'affiliate');
};

// Only same-origin paths are honoured as a post-login redirect target.
export const safeNextPath = (next) => {
  if (typeof next !== 'string') return null;
  if (!next.startsWith('/') || next.startsWith('//')) return null;
  return next;
};
